module.exports = __webpack_public_path__ + "img/logo-title.efcedcd.png";